'use client'

import { Button } from '../button/Button.client'

type DidomiNoticeButtonProps = {
  label: string
}

export function DidomiNoticeButton({ label }: DidomiNoticeButtonProps) {
  return (
    <Button variant="link" onPress={() => window.Didomi?.notice.show()}>
      {label}
    </Button>
  )
}
